module.exports = __webpack_public_path__ + "static/media/vege-fish-breakfasts.792719e7.png";